export const LIMIT = 'limit';
export const OFFSET = 'offset';
export const SORT = 'sort';

export const DESCENDING = '-';
export const DELIMETER = '|';

export const IN = 'in';
export const NOT_IN = 'nin';
export const NOT_EQUAL = 'neq';
export const GREATER_THAN = 'gt';
export const GREATER_THAN_OR_EQUAL = 'gte';
export const LESS_THAN = 'lt';
export const LESS_THAN_OR_EQUAL = 'lte';
export const LIKE = 'like';
export const EQUALS = 'eq';

export const DEFAULT = 'default';
